module.exports = __webpack_public_path__ + "img/profile.f9760f70.svg";